import { render, staticRenderFns } from "./DigitalRewardModal.vue?vue&type=template&id=26538eb8&"
import script from "./DigitalRewardModal.vue?vue&type=script&lang=js&"
export * from "./DigitalRewardModal.vue?vue&type=script&lang=js&"
import style0 from "./DigitalRewardModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports